import { ArrowUpDown, ArrowUp, ArrowDown } from 'lucide-react';
import { TABLE, TYPE } from '../../lib/design-tokens';

/**
 * SortableHeader — Tabel kolom header met sorteergedrag
 *
 * Drie visuele toestanden:
 * - niet gesorteerd: neutraal dubbel pijltje
 * - oplopend: pijl omhoog
 * - aflopend: pijl omlaag
 */
export const SortableHeader = ({ label, field, sortField, sortDir, onSort, className = '' }) => {
  const active = sortField === field;
  return (
    <th
      className={`${TABLE.standard.pad} text-left ${TYPE.tableHeader} cursor-pointer select-none hover:text-neutral-700 transition-colors ${active ? 'text-neutral-700' : ''} ${className}`}
      onClick={() => onSort(field)}
      aria-sort={active ? (sortDir === 'asc' ? 'ascending' : 'descending') : 'none'}
    >
      <span className="inline-flex items-center gap-1">
        {label}
        {active ? (
          sortDir === 'asc'
            ? <ArrowUp className="h-3.5 w-3.5 text-blue-600" strokeWidth={2} />
            : <ArrowDown className="h-3.5 w-3.5 text-blue-600" strokeWidth={2} />
        ) : (
          <ArrowUpDown className="h-3.5 w-3.5 text-neutral-300" strokeWidth={1.5} />
        )}
      </span>
    </th>
  );
};

/**
 * StaticHeader — Niet-sorteerbare tabel kolom header
 */
export const StaticHeader = ({ label, className = '' }) => (
  <th className={`${TABLE.standard.pad} text-left ${TYPE.tableHeader} ${className}`}>
    {label}
  </th>
);

/**
 * TableCell — Gestandaardiseerde tabelcel
 */
export const Td = ({ children, className = '', align = 'left', ...props }) => (
  <td className={`${TABLE.standard.pad} ${TYPE.tableCell} ${align === 'center' ? 'text-center' : ''} ${className}`} {...props}>
    {children}
  </td>
);

/**
 * TableRow — Gestandaardiseerde tabelrij
 */
export const Tr = ({ children, selected, active, onClick, testId, className = '' }) => (
  <tr
    className={`border-b border-neutral-100 transition-colors ${
      active ? 'bg-blue-50/60' :
      selected ? 'bg-blue-50/30' :
      onClick ? 'hover:bg-neutral-50 cursor-pointer' : ''
    } ${className}`}
    onClick={onClick}
    data-testid={testId}
  >
    {children}
  </tr>
);

/**
 * DataTableWrapper — Container voor de hele tabel
 */
export const DataTableWrapper = ({ children, testId = 'data-table' }) => (
  <div className="bg-white overflow-x-auto" data-testid={testId}>
    <table className="w-full">
      {children}
    </table>
  </div>
);

/**
 * TableHead — Standaard tabelkop
 */
export const TableHead = ({ children }) => (
  <thead>
    <tr className="border-b border-neutral-200 bg-neutral-50/80">
      {children}
    </tr>
  </thead>
);

/**
 * ResultsBar — Resultaten teller onderaan de tabel
 */
export const ResultsBar = ({ shown, total, sortLabel, sortDir, testId = 'results-bar' }) => (
  <div className="px-6 py-2.5 border-t border-neutral-100 flex items-center justify-between text-xs text-neutral-400" data-testid={testId}>
    <span>{shown} van {total} resultaten</span>
    {sortLabel && <span>Gesorteerd op {sortLabel} ({sortDir === 'desc' ? 'aflopend' : 'oplopend'})</span>}
  </div>
);
